// extracted by mini-css-extract-plugin
export var layoutContainer = "_4q-0";
export var layoutContainerNoRounding = "_4q-6";
export var layoutContainerOpen = "_4q-5";
export var layoutContainerResizing = "_4q-1";
export var mainContent = "_4q-2";
export var resizeDivider = "_4q-3";
export var slidePanel = "_4q-4";